/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import { formatOptions } from 'Shared/helpers/chart';

const ReactChartJs = loadable.lib(() => import('react-chartjs-2'));

// const hideSlicesPlugin = {
//   afterDraw(chartInstance) {
//     // If `hiddenSlices` has been set.
//     if (chartInstance.config.options.hiddenSlices !== undefined && !chartInstance.config.options.hiddenSlicesSeen) {
//       chartInstance.config.options.hiddenSlicesSeen = true;
//       // Iterate all datasets.
//       for (var i = 0; i < chartInstance.data.datasets.length; ++i) {
//         // Iterate all indices of slices to be hidden.
//         for (let j = 0; j < chartInstance.getDatasetMeta(i).data.length; ++j)
//           chartInstance.getDatasetMeta(i).data[j].hidden = false;
//
//         chartInstance.config.options.hiddenSlices.forEach(index => {
//           // Hide this slice for this dataset.
//           if (chartInstance.getDatasetMeta(i).data[index]) chartInstance.getDatasetMeta(i).data[index].hidden = true;
//         });
//       }
//       chartInstance.update();
//     }
//   },
// };
// Chart.pluginService.register(hideSlicesPlugin);

class PieChart extends Component {
  render() {
    const { height, datasets, labels, options } = this.props;
    const data = { datasets, labels };

    if (!options) {
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
          },
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: { fontSize: 10 },
        },
        scales: {
          xAxes: [
            {
              gridLines: { display: false },
            },
          ],
          yAxes: [
            {
              gridLines: { display: true },
            },
          ],
        },
      };
    }

    return (
      <ReactChartJs>
        {({ Pie, Chart }) => <Pie data={data} options={formatOptions(options, Chart)} height={height} />}
      </ReactChartJs>
    );
  }
}

PieChart.propTypes = {
  height: PropTypes.number,
  datasets: PropTypes.array,
  labels: PropTypes.array,
  options: PropTypes.object,
};

export default connect()(PieChart);
